module.exports = __webpack_public_path__ + "img/research.3bb04710.png";